import { StateInterface, RelationType } from "./types";

const state: StateInterface = {
  loggedIn: false,
  profile: {
    id: 0,
    representee_id: 0,
    first_name: "",
    last_name: "",
    organisation_name: "",
    email_address: "",
    relation_type: RelationType.private
  }
};

export default state;
